import { Backdrop, Button, Card, CardActions, CardContent, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Alert from 'src/components/Alert';
import './imagePreview.css';
import { saveFotograf } from 'src/utils/storage/StrPhoto';
import logger from 'src/utils/logger';
const Compress = require('compress.js').default;
const compress = new Compress();

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


function urltoFile(url, filename, mimeType) {
  return (fetch(url)
    .then(function (res) { return res.arrayBuffer(); })
    .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
  );
}


export const ImagePreview = ({ className, onClose, dataUri, FisNo, DosyaTipi, DosyaTipiText, isFullscreen, issondaj = 0 }) => {
  let classNameFullscreen = isFullscreen ? 'demo-image-preview-fullscreen' : '';
  const classes = useStyles();
  const [Loading, setLoading] = useState(false);

  const [uyari, setUyari] = React.useState(false);
  const [uyariMesaj, setUyariMesaj] = React.useState('');
  const [uyariTip, setUyariTip] = React.useState('success');

  // Component mounted kontrolü için ref
  const isMountedRef = React.useRef(true);

  // Component unmount olduğunda isMountedRef'i false yap
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);



  const MerkezeGonder = () => {
    urltoFile(dataUri, DosyaTipiText, 'image/png')
      .then(async function (filelar) {
        try {
          const file = filelar;
          let FileType = file.type;

          let base64Result = "";

          try {
            const resizedImage = await compress.compress([file], {
              size: 0.2,
              quality: 0.7,
              maxWidth: 1920,
              maxHeight: 1920,
              resize: true
            });

            const img = resizedImage[0];
            base64Result = img.data;
          } catch (compressError) {
            // compress.js EXIF okuma sırasında "Invalid time value" hatası verebilir
            // Bu durumda orijinal dosyayı base64'e çevirip kullan
            logger.warn("Compress error (possibly EXIF date issue):", compressError.message);
            
            // Orijinal dosyayı base64'e çevir
            const reader = new FileReader();
            base64Result = await new Promise((resolve, reject) => {
              reader.onload = () => resolve(reader.result.split(',')[1]);
              reader.onerror = reject;
              reader.readAsDataURL(file);
            });
          }



          if (!isMountedRef.current) return;
          setLoading(true);
          // now upload
          const data = {
            Title: DosyaTipiText,
            MIMEType: DosyaTipi,
            ServiscePaperId: FisNo.toString(),
            DosyaTipi: DosyaTipi.toString(),
            FileData: base64Result,
            issondaj: issondaj.toString()
          }
          const config = {
            headers: { 'Content-Type': 'application/json' }
          }


          if (window.navigator.onLine) {

            await axios.post('/FileImportExport/ArtemisFileUpload', data, config)
              .then(response => {
                if (!isMountedRef.current) return;
                onClose(dataUri);
                setLoading(false);
              }).catch(error => {
                if (!isMountedRef.current) return;
                
                // Hata detaylarını logla
                logger.error("ImagePreview Upload Hatası:", {
                  message: error.message,
                  status: error.response?.status,
                  statusText: error.response?.statusText,
                  data: error.response?.data
                });

                // Kullanıcıya hata mesajı göster
                if (error.response?.status === 502) {
                  setUyariMesaj('Dosya çok büyük veya sunucu meşgul. Fotoğraf offline kaydedildi.');
                  setUyariTip('warning');
                } else if (error.response?.status === 413) {
                  setUyariMesaj('Dosya boyutu çok büyük. Fotoğraf offline kaydedildi.');
                  setUyariTip('warning');
                } else {
                  setUyariMesaj('Sunucuya yüklenemedi. Fotoğraf offline kaydedildi.');
                  setUyariTip('warning');
                }
                setUyari(true);

                // Offline kaydet
                saveFotograf(FisNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
                setLoading(false);
                onClose(dataUri);
              });

          } else {
            if (!isMountedRef.current) return;
            saveFotograf(FisNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
            setLoading(false);
            onClose(dataUri);
          }
        } catch (error) {
          if (!isMountedRef.current) return;
          logger.error("ImagePreview Genel Hata:", error);
          
          // Kullanıcıya bilgi ver
          setUyariMesaj('Fotoğraf yüklenirken hata oluştu. Offline kaydedildi.');
          setUyariTip('error');
          setUyari(true);
          setLoading(false);
        }

      });

  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <Card className={clsx(classes.root, className)}>
      <CardActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={MerkezeGonder}
          className={classes.submitButton}
          endIcon={<SendIcon>Gönder</SendIcon>}
        >
          Fotoğrafı Fişe Ekle
        </Button>
      </CardActions>
      <CardContent className={classes.content}>
        {
          Loading ?
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Typography variant="h6" gutterBottom>
          {FisNo} {DosyaTipiText}
        </Typography>
        <div className={'demo-image-preview ' + classNameFullscreen}>
          <img src={dataUri} alt="" />
        </div>
        {
          uyari ?
            <Alert onClose={handleClose} message={uyariMesaj} variant={uyariTip} />
            : <div></div>
        }
      </CardContent>
    </Card>

  );
};

ImagePreview.propTypes = {
  dataUri: PropTypes.string,
  isFullscreen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ImagePreview;
